import {
    PlusCircleOutlined,
    LoadingOutlined,
    FileImageOutlined,
} from "@ant-design/icons";
import {
    Button,
    Col,
    Form,
    InputNumber,
    message,
    Modal,
    Row,
} from "antd";
import React, { useState } from "react";
import {
    getListGiftExchange,
} from "../../../api/giftExchange/giftExchange";
import { useDispatch } from "react-redux";
import { giftExchangeAPIWithErrorHandling } from "../../../api/giftExchange/giftExchangeApi";
import { brand, semantic, neutral } from "../../../theme/tokens";

export default function InStockGiftExchange({
    isModalOpen,
    currentPage,
    pageSize,
    handleOk,
    handleCancel,
    record,
}) {
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();

    const dispatch = useDispatch();

    const handleFormSubmit = async (values) => {

        try {
            setIsLoading(true);

            const dataPay = {
                quantity: values.quantity
            };

            await giftExchangeAPIWithErrorHandling.inStock(
                record.id,
                dataPay
            );

            message.success("Cập nhập thành công!");

            // Refresh data
            await dispatch(getListGiftExchange({ currentPage, pageSize }));
            handleOk();
        } catch (error) {
            message.error(error.message || "Cập nhập thất bại");
        } finally {
            setIsLoading(false);
        }
    };

    const handleCancelModal = () => {
        form.resetFields();
        handleCancel(); // gọi prop
    };

    const modalFooter = [
        <Button
            key="cancel"
            onClick={handleCancelModal}
            style={{ minWidth: '100px' }}
        >
            Hủy bỏ
        </Button>,
        <Button
            key="submit"
            type="primary"
            icon={isLoading ? <LoadingOutlined /> : <PlusCircleOutlined />}
            onClick={() => form.submit()}
            loading={isLoading}
        >
            {isLoading ? 'Đang cập nhật...' : 'Cập nhật'}
        </Button>,
    ];

    return (
        <>
            <Modal
                title={
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <FileImageOutlined style={{ color: brand.accent, fontSize: '20px' }} />
                        <span style={{ fontSize: '18px', fontWeight: '600' }}>
                            Cập nhập số lượng quà tặng
                        </span>
                    </div>
                }
                open={isModalOpen}
                footer={modalFooter}
                onCancel={handleCancel}
                width="50%"
                centered
                maskClosable={false}
                styles={{
                    body: {
                        padding: "24px",
                        maxHeight: "calc(100vh - 200px)",
                        overflow: "auto",
                        textAlign: "center"
                    },
                    header: {
                        borderBottom: '1px solid #f0f0f0',
                        paddingBottom: '16px',
                        marginBottom: '0'
                    }
                }}
            >
                <Form form={form} layout="vertical" onFinish={handleFormSubmit}>
                    <Row gutter={[16, 0]}>
                        {/* Thông tin tồn kho hiện tại */}
                        <Col span={24}>
                            <div
                                style={{
                                    background: "#f8f9fa",
                                    border: "1px solid #e9ecef",
                                    borderRadius: "8px",
                                    padding: "16px 20px",
                                    marginBottom: "20px",
                                    textAlign: "left",
                                }}
                            >
                                <div
                                    style={{
                                        fontWeight: 600,
                                        fontSize: "13px",
                                        color: "#6c757d",
                                        marginBottom: "12px",
                                        textTransform: "uppercase",
                                        letterSpacing: "0.5px",
                                    }}
                                >
                                    Thông tin tồn kho hiện tại
                                </div>
                                <Row gutter={16}>
                                    <Col xs={24} sm={12} md={8} span={8}>
                                        <div style={{ textAlign: "center" }}>
                                            <div style={{ fontSize: "22px", fontWeight: 700, color: brand.accent }}>
                                                {record?.total_stock ?? 0}
                                            </div>
                                            <div style={{ fontSize: "12px", color: neutral[500], marginTop: "2px" }}>
                                                Tổng số lượng
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xs={24} sm={12} md={8} span={8}>
                                        <div style={{ textAlign: "center" }}>
                                            <div style={{ fontSize: "22px", fontWeight: 700, color: semantic.success }}>
                                                {record?.stock ?? 0}
                                            </div>
                                            <div style={{ fontSize: "12px", color: neutral[500], marginTop: "2px" }}>
                                                Số lượng hiện tại
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xs={24} sm={12} md={8} span={8}>
                                        <div style={{ textAlign: "center" }}>
                                            <div style={{ fontSize: "22px", fontWeight: 700, color: semantic.danger }}>
                                                {(record?.total_stock ?? 0) - (record?.stock ?? 0)}
                                            </div>
                                            <div style={{ fontSize: "12px", color: neutral[500], marginTop: "2px" }}>
                                                Đã sử dụng
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>

                        {/* Input nhập số lượng bổ sung */}
                        <Col span={24}>
                            <Form.Item
                                label={
                                    <span style={{ fontWeight: 500 }}>
                                        Nhập số lượng bổ sung
                                    </span>
                                }
                                name="quantity"
                                rules={[
                                    { required: true, message: "Vui lòng nhập số lượng bổ sung" },
                                    {
                                        validator: (_, value) => {
                                            if (value === null || value === undefined || value === "") {
                                                return Promise.reject("Vui lòng nhập số lượng bổ sung");
                                            }
                                            if (isNaN(value) || Number(value) <= 0) {
                                                return Promise.reject("Số lượng bổ sung phải lớn hơn 0");
                                            }
                                            return Promise.resolve();
                                        },
                                    },
                                ]}
                            >
                                <InputNumber
                                    min={1}          // ✅ không cho nhập số < 1 trên UI
                                    precision={0}    // ✅ chỉ nhận số nguyên, không cho nhập số thập phân
                                    style={{ width: "100%" }}
                                    placeholder="Nhập số lượng cần bổ sung..."
                                    size="large"
                                    formatter={(value) =>
                                        value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ""
                                    }
                                    parser={(value) => value?.replace(/,/g, "")}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        </>
    );
}